import { render, staticRenderFns } from "./game-month-rounds2.vue?vue&type=template&id=c14d90f8&scoped=true"
import script from "./game-month-rounds2.vue?vue&type=script&lang=js"
export * from "./game-month-rounds2.vue?vue&type=script&lang=js"
import style0 from "./game-month-rounds2.vue?vue&type=style&index=0&id=c14d90f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c14d90f8",
  null
  
)

export default component.exports